import PropTypes from "prop-types";
import { styled } from "@mui/material/styles";
import Dialog from "@mui/material/Dialog";
import DialogTitle from "@mui/material/DialogTitle";
import IconButton from "@mui/material/IconButton";
import CloseIcon from "@mui/icons-material/Close";

const BootstrapDialog = styled(Dialog)(({ theme }) => ({
  "& .MuiDialogContent-root": {
    padding: theme.spacing(2),
  },
  "& .MuiDialogActions-root": {
    padding: theme.spacing(1),
  },
}));

function BootstrapDialogTitle(props) {
  const { children, onClose, othersx, ...other } = props;

  return (
    <DialogTitle sx={{ m: 0, p: 2, ...othersx }} {...other}>
      {children}
      {onClose ? (
        <IconButton
          aria-label="close"
          onClick={onClose}
          sx={{
            position: "absolute",
            right: 8,
            top: 8,
            color: (theme) => theme.palette.grey[500],
          }}
        >
          <CloseIcon />
        </IconButton>
      ) : null}
    </DialogTitle>
  );
}

BootstrapDialogTitle.propTypes = {
  children: PropTypes.node,
  onClose: PropTypes.func.isRequired,
};

export default function DialogData(props) {
  const {
    openDialogContent,
    handleCloseDialogContent,
    dialogTitle,
    children,
    dialogType,
  } = props;
  const othersx = (selected) => {
    switch (selected) {
      case "deleteWord":
        return { backgroundColor: "red" };
      case "editword":
        return { backgroundColor: "orange" };
      default:
        return {};
    }
  };

  return (
    <div>
      <BootstrapDialog
        onClose={handleCloseDialogContent}
        aria-labelledby="customized-dialog-title"
        open={openDialogContent}
        maxWidth="xl"
      >
        <BootstrapDialogTitle
          id="customized-dialog-title"
          onClose={handleCloseDialogContent}
          othersx={othersx(dialogType)}
        >
          {dialogTitle}
        </BootstrapDialogTitle>
        {children}
      </BootstrapDialog>
    </div>
  );
}
